import React, { Fragment } from "react";
import "./Breadcrumb.scss";
import { ReactSVG } from 'react-svg';
import breadcrumb from '../../Assets/icons/breadcrumb.svg';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = (props) => {
    const { pageName } = props;
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter(x => x);

    if(process.env.REACT_APP_IS_RESELLER) return null

    return (
        <div className="breadcrumb">
            <ReactSVG className="icon" src={breadcrumb} />
            <Link key={0} className="item" to={"/"}>Dashboard</Link>
            <div className="divider"></div>
            <Link key={1} className="item" to={`/${pathnames.slice(0, 1).join("/")}`}>{pathnames.slice(0, 1)}</Link>
            {pageName && 
                <Fragment>
                    <div className="divider"></div>
                    <span key={2} className="item nolink">{pageName}</span>
                </Fragment>
            }
        </div>
    );
};

export default Breadcrumb;
